export default __webpack_public_path__ + "static/media/lupa.1c74d855.svg";